export const menuItems = [
    {
        id: 100,
        label: "menuitems.menu.text",
        isTitle: true,
        link:"/",
        role:["SuperAdmin","*"],
        subItems: []
    },
    
    {
        id: 200,
        label: "menuitems.AnktAnket.text",
        icon: "bx bxs-report",
        link: "/AnktAnket",
        role:["SuperAdmin","AnketAdmin","AnketKullanici"],
        subItems: []
       
    },
    {
        id: 300, 
        icon: "bx bxs-report",
        link: "/AnktAnketCevap",
        hide: true,
        role:["SuperAdmin","AnketAdmin","AnketKullanici",""],
        subItems: []
       
    },
    {
        id: 400, 
        icon: "bx bxs-report",
        link: "/AnktForm",
        hide: true,
        role:["SuperAdmin","AnketAdmin","AnketKullanici"],
        subItems: []
       
    },
    {
        id: 500, 
        icon: "bx bxs-report",
        link: "/AnktDetay",
        hide: true,
        role:["SuperAdmin","AnketAdmin","AnketKullanici"],
        subItems: []
       
    },
    {
        id: 100,  
        link:"/logout",
        role:["*"],
        hide: true,
        subItems: []
    },
    
    {
        id: 100, 
        isTitle: true,
        link: "/userroles",
        hide: true,
        role: ["SuperAdmin","AnketAdmin"],
        subItems: [],
    },
    {
        id: 100, 
        isTitle: true,
        link: "/ouserbirimyetki",
        hide: true,
        role: ["SuperAdmin","AnketAdmin"],
        subItems: [],
    },

];

